export default [
  {
    path: '/protocol/vip',
    name: 'vipProtocol',
    component: () => import('@/view/protocol/vip'),
    meta: { pageName: 'page_vip_protocol' }
  },
  {
    path: '/protocol/vip-jw',
    name: 'vipJwProtocol',
    component: () => import('@/view/protocol/vip-jw'),
    meta: { pageName: 'page_vip_jw_protocol' }
  },
  {
    path: '/protocol/auth-jw',
    name: 'authJwProtocol',
    component: () => import('@/view/protocol/auth-jw'),
    meta: { pageName: 'page_auth_jw_protocol' }
  },
  {
    path: '/protocol/service-jw',
    name: 'serviceJwProtocol',
    component: () => import('@/view/protocol/service-jw'),
    meta: { pageName: 'page_service_jw_protocol' }
  },
  // ============== wh ==============
  {
    path: '/protocol/vip-wh',
    name: 'vipWhProtocol',
    component: () => import('@/view/protocol/wh/vip-wh'),
    meta: { pageName: 'page_vip_wh_protocol' }
  },
  {
    path: '/protocol/vip-wh-bf',
    name: 'vipWhProtocolBf',
    component: () => import('@/view/protocol/wh/vip-wh-bf'),
    meta: { pageName: 'page_vip_wh_protocol_bf' }
  },
  {
    path: '/protocol/vip-wh-c',
    name: 'vipWhProtocolC',
    component: () => import('@/view/protocol/wh/vip-wh-c'),
    meta: { pageName: 'page_vip_whc_protocol' }
  },
  {
    path: '/protocol/auth-wh',
    name: 'authWhProtocol',
    component: () => import('@/view/protocol/wh/auth-wh'),
    meta: { pageName: 'page_auth_wh_protocol' }
  },
  {
    path: '/protocol/auth-wh-bf',
    name: 'authWhProtocolBf',
    component: () => import('@/view/protocol/wh/auth-wh-bf'),
    meta: { pageName: 'page_auth_wh_protocol_bf' }
  },
  {
    path: '/protocol/service-wh',
    name: 'serviceWhProtocol',
    component: () => import('@/view/protocol/wh/service-wh'),
    meta: { pageName: 'page_service_wh_protocol' }
  },
  {
    path: '/protocol/deduction-wh',
    name: 'serviceWhDeduction',
    component: () => import('@/view/protocol/wh/deduction-wh'),
    meta: { pageName: 'page_deduction_wh_protocol' }
  },
  {
    path: '/protocol/deduction-bf',
    name: 'serviceWhDeductionBf',
    component: () => import('@/view/protocol/wh/deduction-bf'),
    meta: { pageName: 'page_deduction_wh_protocol_bf' }
  },
  {
    path: '/protocol/deduction-wh-bf',
    name: 'serviceWhDeductionWhBf',
    component: () => import('@/view/protocol/wh/deduction-wh-bf'),
    meta: { pageName: 'page_deduction_wh_protocol_wh_bf' }
  },
  {
    path: '/protocol/deduction-lf-bf',
    name: 'serviceWhDeductionLfBf',
    component: () => import('@/view/protocol/wh/deduction-lf-bf'),
    meta: { pageName: 'page_deduction_wh_protocol_lf_bf' }
  },
  
  {
    path: '/protocol/auth',
    name: 'authProtocol',
    component: () => import('@/view/protocol/auth'),
    meta: { pageName: 'page_auth_protocol' }
  },
  {
    path: '/protocol/deduction',
    name: 'deductionProtocol',
    component: () => import('@/view/protocol/deduction'),
    meta: { pageName: 'page_deduction_protocol' }
  },
  {
    path: '/protocol/vip-lf',
    name: 'vipProtocolLf',
    component: () => import('@/view/protocol/vip_lf'),
    meta: { pageName: 'page_vip_protocol_lf' }
  },
  {
    path: '/protocol/auth_lf',
    name: 'authProtocolLf',
    component: () => import('@/view/protocol/auth_lf'),
    meta: { pageName: 'page_auth_protocol_lf' }
  }, {
    path: '/protocol/deduction-bf',
    name: 'deductionProtocolBf',
    component: () => import('@/view/protocol/deduction-bf'),
    meta: { pageName: 'page_deduction_protocol_bf' }
  }, {
    path: '/protocol/deduction-lf-bf',
    name: 'deductionProtocolLfBf',
    component: () => import('@/view/protocol/deduction-lf-bf'),
    meta: { pageName: 'page_deduction_protocol_lf_bf' }
  } 
]